"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGoodsEnum = exports.requisitionRulesEnum = exports.isOvertEnum = exports.discountMethodsEnum = exports.companyAppStatus = void 0;
var companyAppStatus = exports.companyAppStatus = [];

//优惠方式
var discountMethodsEnum = exports.discountMethodsEnum = [{
  label: '满减券',
  value: 1
}, {
  label: '折扣券',
  value: 2
}];

//领用规则
var requisitionRulesEnum = exports.requisitionRulesEnum = [{
  label: '每人限领1张',
  value: 1
}, {
  label: '每人每天限领1张',
  value: 2
}];

//是否公开
var isOvertEnum = exports.isOvertEnum = [{
  label: '不公开',
  value: 0
}, {
  label: '公开',
  value: 1
}];

//使用商品
var useGoodsEnum = exports.useGoodsEnum = [{
  label: '全部商品添加',
  value: 1
}, {
  label: '指定商品参加',
  value: 2
}, {
  label: '指定商品不参加',
  value: 3
}, {
  label: '指定分类参加',
  value: 4
}];